export default __webpack_public_path__ + "static/media/Snd_LowerMDivedown.3a1657b5.mp3";